import { addDays, parseKey, relDayLabel, todayKey } from "../lib/date";

// Plan-page date navigator: page any direction with the arrows, jump via the
// quick chips or the date picker, and reset to today.
export function DateNav({
  date,
  onChange,
}: {
  date: string;
  onChange: (date: string) => void;
}) {
  const today = todayKey();
  const isToday = date === today;
  const full = parseKey(date).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const chips = [0, 1, 2, 3].map((n) => addDays(today, n));
  const chipLabel = (key: string, i: number) =>
    i === 0
      ? "Today"
      : i === 1
        ? "Tomorrow"
        : parseKey(key).toLocaleDateString("en-GB", { weekday: "short", day: "numeric" });

  return (
    <div className="datenav">
      <div className="datenav-main">
        <button
          className="datenav-arrow"
          onClick={() => onChange(addDays(date, -1))}
          aria-label="Previous day"
        >
          ‹
        </button>
        <div className="datenav-cur">
          <div className="datenav-date">
            <span
              className="datenav-dot"
              style={{ background: isToday ? "var(--ok)" : "var(--accent)" }}
            />
            {full}
          </div>
          <div className={`datenav-rel${isToday ? "" : " ahead"}`}>
            {relDayLabel(date, today)}
          </div>
        </div>
        <button
          className="datenav-arrow"
          onClick={() => onChange(addDays(date, 1))}
          aria-label="Next day"
        >
          ›
        </button>
        {!isToday && (
          <button className="datenav-reset" onClick={() => onChange(today)}>
            ↩ Today
          </button>
        )}
      </div>

      <div className="datenav-chips">
        {chips.map((key, i) => (
          <button
            key={key}
            className={`datenav-chip${date === key ? " on" : ""}`}
            onClick={() => onChange(key)}
          >
            {chipLabel(key, i)}
          </button>
        ))}
        <input
          className="datenav-pick"
          type="date"
          value={date}
          onChange={(e) => e.target.value && onChange(e.target.value)}
          aria-label="Pick a date"
        />
      </div>
    </div>
  );
}
